import React from 'react';
import Translation from '../../../../Shared/components/Translation';
import { ZdsDivider, ZdsLink } from '@zig-design-system/ui-components-react';
const ResourcesList = ({ title, resources }) => {
    if (resources.every((url) => url === null)) {
        return null;
    }
    return (React.createElement("div", { className: "real-estate__property-group" },
        React.createElement("dl", null,
            React.createElement("dt", null,
                React.createElement("h2", { className: "zds-headline-md" },
                    React.createElement(Translation, { item: title }))),
            React.createElement("dd", null,
                React.createElement(React.Fragment, null, resources.map((resource, index) => {
                    if (!resource.url) {
                        return null;
                    }
                    return (React.createElement("div", { className: "zds-row zds-margin-bottom-1", key: index },
                        React.createElement(ZdsLink, { link: resource.url, linkTarget: '_blank' }, resource.name)));
                })))),
        React.createElement(ZdsDivider, { className: 'zds-margin-y-4 md:zds-margin-y-8' })));
};
export default ResourcesList;
